<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Services" />
            <ServicesComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ServicesComp from '../ServicesTwo/ServicesComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ServicesTwoPage',
    components: {
        NavBar,
        PageTitle,
        ServicesComp,
        FooterComp,
    }
}
</script>